import React from 'react'
import StarRatingComponent from 'react-star-rating-component';
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';

const RateBox = ({ rateItem, price }) => (
    <div className="description__rate">
        {price && <div className="price">تومان {price}</div>}
        {/* <div className="conversation-number">
            <QuestionAnswerIcon className="conversation-icon" style={{ fontSize: 12, marginLeft: 5 }} />
            &nbsp;
            {((rateItem && rateItem.count) || 0).toLocaleString("fa-IR")}  مشاوره
        </div> */}

        <div className="star-rate">
            <StarRatingComponent
                name="rate of doctor"
                editing={false}
                renderStarIcon={() => <StarRoundedIcon style={{ display: 'flex', fontSize: '10px', marginLeft: 2 }} />}
                starCount={5}
                value={(rateItem && rateItem.rate) || 0}
            />
            &nbsp;
            {Number((rateItem && rateItem.rate && rateItem.rate.toFixed(1)) || 0).toLocaleString("fa-IR")}
        </div>

        <div className="number-rate">
            (از&nbsp;{((rateItem && rateItem.rateCount) || 0).toLocaleString("fa-IR")}&nbsp;نظر)
        </div>
    </div>
)

export default RateBox